import useDisplayModal from '../hooks/useDisplayModal';
import TCPopup from './modals/T&CPopup';

const PayOutChartPercentageProgram = ({open, close}) => {
    const { open: showTCPopup, handleOpen: openTCPopup, handleClose: closeTCPopup} = useDisplayModal();

    return (
        <>
            <div className="popup-content payout-chart percentage-program">
                <h3>Payout Chart - Percentage Program</h3>

                <div className="content">
                    <div className="table">
                        <table className="auto-name">
                            <thead>
                                <tr>
                                    <th>Traffic</th>
                                    <th colspan="2">Commission</th>
                                </tr>

                                <tr className="rows">
                                    <th>Traffic Per Month</th>
                                    <th>Initial Order</th>
                                    <th>Recurring</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="rows alt">
                                    <td>Average 1-10 uniques per day</td>
                                    <td>50 %</td>
                                    <td>50 %</td>
                                </tr>

                                <tr className="rows">
                                    <td>Average 11-99 uniques per day</td>
                                    <td>55 %</td>
                                    <td>50 %</td>
                                </tr>

                                <tr className="rows alt">
                                    <td>Average 100+ uniques per day</td>
                                    <td>60 %</td>
                                    <td>50 %</td>
                                </tr>

                                <tr className="rows">
                                    <td>Average 10-19 joins per day</td>
                                    <td>65 %</td>
                                    <td>50 %</td>
                                </tr>

                                <tr className="rows alt">
                                    <td>Average 20-29 joins per day</td>
                                    <td>70 %</td>
                                    <td>50 %</td>
                                </tr>

                                <tr className="rows">
                                    <td>Average 30+ joins per day</td>
                                    <td>75 %</td>
                                    <td>50 %</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                    <h5>Percentage Program - Minimum Requirements</h5>
                    <ul>
                        <li>
                            Female join bonus amount/s only becomes due &amp; payable if at least one referred registered user becomes a paid member of RedHotPie during the same calendar month.
                            <br /><br />
                            For full details refer to <a href="" onClick={e=>{e.preventDefault();openTCPopup()}}>Affiliate Agreement.</a>
                        </li>
                    </ul>

                </div>
            </div>

        <TCPopup open={showTCPopup} close={closeTCPopup} />
        </>
    )
}

export default PayOutChartPercentageProgram;